import { SlingoEvent } from "@lib/titan2-slingo/dist/game/controller/event/SlingoEvent";
import { WinController } from "@lib/titan2-slingo/dist/game/controller/WinController";
import { ArrayUtil } from "@lib/titan2/dist/util/collection/ArrayUtil";
import { Dictionary } from "@lib/titan2/dist/util/collection/Dictionary";
import { Service } from "@lib/titan2-slingo/dist/api/Service";
/**
 * GameWinController.ts
 */
export class GameWinController extends WinController {
    updateAvailableWins() {
        const payoutConfig = this.model.getPayoutConfig();
        const payouts = payoutConfig.getPatternPayouts();
        const maxPatterns = payouts.length;
        const stake = this.model.getCurrentStake();
        const matchedPatterns = this.model.getCurrentMatchedPatterns();
        const numberOfPatterns = matchedPatterns + 1;
        const winsByKey = new Dictionary();
        for (let i = numberOfPatterns; i <= maxPatterns; i++) {
            let winAmount = this.getWinAmount(stake, payouts[i - 1]);
            if (i >= 5) {
                const patternCombination = this.patterns.getValue(i);
                for (let j = 0; j < patternCombination.length; j++) {
                    const patternSet = patternCombination[j];
                    const availableWin = this.createAvailableWin(patternSet, i, winAmount);
                    if (availableWin) {
                        winsByKey.setValue(availableWin.getKey(), availableWin);
                    }
                }
            }
        }
        const availableWinsArray = winsByKey.getValues();
        const pickedWins = ArrayUtil.groupBy(availableWinsArray, (elem) => elem.getNumberOfPatterns());
        const pickedWinKeys = Object.keys(pickedWins).filter(key => pickedWins.hasOwnProperty(key));
        const pickedWinsArray = pickedWinKeys.map(key => pickedWins[key][Math.floor(Math.random() * pickedWins[key].length)]);
        this.model.setAvailableWins(pickedWinsArray.sort((a, b) => b.getNumberOfPatterns() - a.getNumberOfPatterns()));
        this.model.setAvailableWinIndex(-1);
        return pickedWinsArray.length > 0;
    }
    handlePurchaseSpin() {
        if (this.model.isSpin() && !this.model.isChooseCell() && !this.model.getSpinResultResolving() && !Service.isReplay()) {
            this.dispatchGame(SlingoEvent.AVAILABLE_WIN_START);
            let winAvailable = this.updateAvailableWins();
            if (winAvailable) {
                this.startWinTimer(200);
            }
        }
    }
    handleClearWin() {
        this.clearWinTimer.stop();
        this.dispatchGame(SlingoEvent.AVAILABLE_WIN_CLEAR);
        this.startWinTimer(0);
    }
}
//# sourceMappingURL=GameWinController.js.map